const LAYOUT_ORIENTATION = {
    VERTICAL: 'VERTICAL',
    HORIZONTAL: 'HORIZONTAL',
};
export default LAYOUT_ORIENTATION;
//# sourceMappingURL=layoutParams_structure_layoutOrientation.js.map